import { APP_EVENTS, type Game } from "@/phaser/Game";
import { GameStatus } from "@phaser/core/game/GameStateController";

type RegisterAppLifecycleEventsOptions = {
  scene: Phaser.Scene;
  game: Game;
  getStatus: () => GameStatus;
  pause: () => void;
  getPausedByBackground: () => boolean;
  setPausedByBackground: (value: boolean) => void;
};

export function registerAppLifecycleEvents({
  scene,
  game,
  getStatus,
  pause,
  getPausedByBackground,
  setPausedByBackground,
}: RegisterAppLifecycleEventsOptions) {
  const onBg = () => {
    if (getStatus() === GameStatus.RUNNING) {
      setPausedByBackground(true);
      pause();
    }
  };

  const onFg = () => {
    if (getPausedByBackground()) {
      setPausedByBackground(false);
    }
  };

  game.appEvents.on(APP_EVENTS.BACKGROUND, onBg);
  game.appEvents.on(APP_EVENTS.FOREGROUND, onFg);

  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    game.appEvents.off(APP_EVENTS.BACKGROUND, onBg);
    game.appEvents.off(APP_EVENTS.FOREGROUND, onFg);
  });
}

type RegisterGameStateEventsOptions = {
  scene: Phaser.Scene;
  subscribeChanged: (callback: (next: GameStatus) => void) => () => void;
  subscribeExitHome: (callback: () => void) => () => void;
  onPause: () => void;
  onResume: () => void;
  onGameOver: () => void;
  onExitHome: () => void;
};

export function registerGameStateEvents({
  scene,
  subscribeChanged,
  subscribeExitHome,
  onPause,
  onResume,
  onGameOver,
  onExitHome,
}: RegisterGameStateEventsOptions) {
  const offChanged = subscribeChanged((next) => {
    if (next === GameStatus.PAUSED) {
      onPause();
    }

    if (next === GameStatus.RUNNING) {
      onResume();
    }

    if (next === GameStatus.GAME_OVER) {
      onGameOver();
    }
  });

  const offExitHome = subscribeExitHome(onExitHome);

  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    offChanged();
    offExitHome();
  });
}
